(function() {
    function funcReady() {
        $('.KRP0025').buildCommonUI();

        vcui.require(['ui/carousel'], function () {
            $('.KRP0025').find(".ui_carousel_slider").each(function(cdx, slide){
                $(slide).vcCarousel({
                    infinite: false,
                    autoplay: false,
                    // prevArrow:'.btn-arrow.prev',
                    // nextArrow:'.btn-arrow.next',
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToScroll: 1,
                                slidesToShow: 1
                            }
                        },
                        {
                            breakpoint: 20000,
                            settings: {
                                slidesToScroll: 2,
                                slidesToShow: 2
                            }
                        }
                    ]
                });
            });
        });
    }

    // BTOCSITE-26022, PDP 컴포넌트 초기화 함수 추가, type: PROD or CONTENTS
    function SAVE_COMPONENT_PDP_DOM_MNG() {
        if (typeof __PDP_DOM_MNG__ === 'undefined') return;
        __PDP_DOM_MNG__.add({
            type: 'CONTENTS', name: 'KRP0025', isFirstLoad: false, fn: function () {
                if(!document.querySelector('.KRP0025')) return false;
                funcReady();
            }
        });
    }

    SAVE_COMPONENT_PDP_DOM_MNG();

    $(window).ready(function(){
        SAVE_COMPONENT_PDP_DOM_MNG();

        if(!document.querySelector('.KRP0025')) return false;
        funcReady();
    });
})();

